// Vestavěné výchozí texty (cs/en). Konfigurace je může přepsat.
import type { CategoryId, Lang, Texts } from './types';

export const DEFAULT_TEXTS: Record<Lang, Texts> = {
  cs: {
    'banner.title': 'Tento web používá cookies',
    'banner.body':
      'Používáme cookies, abychom web správně fungoval, a s vaším souhlasem také k analýze návštěvnosti a marketingu. Souhlas můžete kdykoli odvolat.',
    'banner.acceptAll': 'Povolit vše',
    'banner.rejectAll': 'Odmítnout',
    'banner.settings': 'Nastavení',
    'banner.moreInfo': 'Více informací',
    'modal.title': 'Nastavení souhlasu',
    'modal.intro':
      'Zde si můžete zvolit, které kategorie cookies povolíte. Nutné cookies jsou vždy aktivní.',
    'modal.save': 'Uložit volbu',
    'modal.acceptAll': 'Povolit vše',
    'modal.rejectAll': 'Odmítnout vše',
    'modal.close': 'Zavřít',
    'modal.cookiesShown': 'Použité cookies',
    'modal.provider': 'Poskytovatel',
    'modal.expiry': 'Platnost',
    'modal.always': 'Vždy aktivní',
    'reopen.label': 'Nastavení cookies',
    'cat.necessary.name': 'Nutné',
    'cat.necessary.desc':
      'Umožňují základní funkce webu jako navigaci a přístup k zabezpečeným částem. Web bez nich nefunguje.',
    'cat.preferences.name': 'Preferenční',
    'cat.preferences.desc':
      'Umožňují webu zapamatovat si volby, které mění jeho chování nebo vzhled — např. jazyk nebo region.',
    'cat.statistics.name': 'Statistické',
    'cat.statistics.desc':
      'Pomáhají porozumět tomu, jak návštěvníci web používají. Sbírají a hlásí informace anonymně.',
    'cat.marketing.name': 'Marketingové',
    'cat.marketing.desc':
      'Slouží ke sledování návštěvníků napříč weby za účelem zobrazení relevantní reklamy.',
    'cat.unclassified.name': 'Neklasifikované',
    'cat.unclassified.desc':
      'Neklasifikované cookies jsou cookies, které máme v procesu klasifikování společně s poskytovateli jednotlivých cookies.',
    'trigger.title': 'Nastavení cookies',
    'trigger.state': 'Váš současný stav',
    'trigger.date': 'Datum souhlasu',
    'trigger.id': 'ID Vašeho souhlasu',
    'trigger.change': 'Změnit souhlas',
    'trigger.withdraw': 'Odebrat souhlas',
    'trigger.showDetails': 'Zobrazit detaily',
    'trigger.hideDetails': 'Skrýt detaily',
    'trigger.none': 'Zatím jste o cookies nerozhodli.',
    'trigger.about':
      'Pro zlepšování našich služeb používáme cookies. K personalizaci obsahu a reklam a analýze naší návštěvnosti využíváme soubory cookie. Informace o tom, jak náš web používáte, sdílíme se svými partnery pro sociální média, inzerci a analýzy. Partneři tyto údaje mohou zkombinovat s dalšími informacemi, které jste jim poskytli nebo které získali v důsledku toho, že používáte jejich služby.\n\n' +
      'Cookies jsou malé textové soubory, které mohou být používány webovými stránkami, aby učinily uživatelský zážitek více efektivní.\n\n' +
      'Zákon uvádí, že můžeme ukládat cookies na vašem zařízení, pokud jsou nezbytně nutné pro provoz této stránky. Pro všechny ostatní typy cookies potřebujeme vaše povolení.\n\n' +
      'Tato stránka používá různé typy cookies. Některé cookies jsou umístěny službami třetích stran, které se objevují na našich stránkách.\n\n' +
      'Kdykoliv můžete změnit nebo zrušit svůj souhlas prostřednictvím Vyjádření o souborech cookie na našich webových stránkách.\n\n' +
      'Zjistěte v našich zásadách ochrany osobních údajů více o tom, kdo jsme, jak nás můžete kontaktovat a jak zpracováváme vaše osobní údaje.\n\n' +
      'Uveďte prosím ID svého souhlasu a datum, kdy nás budete kontaktovat ohledně vašeho souhlasu.',
    'trigger.domains': 'Váš souhlas se týká následujících domén:',
    'trigger.colName': 'Název',
    'trigger.colProvider': 'Poskytovatel',
    'trigger.colPurpose': 'Účel',
    'trigger.colExpiry': 'Platnost',
    'trigger.colType': 'Typ',
    'trigger.noCookies': 'Tento typ cookies nepoužíváme.',
    'type.cookie': 'HTTP cookie',
    'type.localStorage': 'Local storage',
    'type.indexedDb': 'IndexedDB',
    'type.pixel': 'Pixel',
    'type.other': 'Jiné',
  },
  en: {
    'banner.title': 'This website uses cookies',
    'banner.body':
      'We use cookies to make the site work and, with your consent, to analyse traffic and for marketing. You can withdraw consent at any time.',
    'banner.acceptAll': 'Allow all',
    'banner.rejectAll': 'Decline',
    'banner.settings': 'Settings',
    'banner.moreInfo': 'More information',
    'modal.title': 'Consent settings',
    'modal.intro':
      'Choose which cookie categories you allow. Necessary cookies are always active.',
    'modal.save': 'Save choice',
    'modal.acceptAll': 'Allow all',
    'modal.rejectAll': 'Decline all',
    'modal.close': 'Close',
    'modal.cookiesShown': 'Cookies used',
    'modal.provider': 'Provider',
    'modal.expiry': 'Expiry',
    'modal.always': 'Always active',
    'reopen.label': 'Cookie settings',
    'cat.necessary.name': 'Necessary',
    'cat.necessary.desc':
      'Enable core site functions such as navigation and access to secure areas. The site cannot work properly without them.',
    'cat.preferences.name': 'Preferences',
    'cat.preferences.desc':
      'Allow the site to remember choices that change its behaviour or look — such as language or region.',
    'cat.statistics.name': 'Statistics',
    'cat.statistics.desc':
      'Help us understand how visitors use the site. They collect and report information anonymously.',
    'cat.marketing.name': 'Marketing',
    'cat.marketing.desc':
      'Used to track visitors across websites to display relevant advertising.',
    'cat.unclassified.name': 'Unclassified',
    'cat.unclassified.desc':
      'Unclassified cookies are cookies that we are in the process of classifying, together with the providers of individual cookies.',
    'trigger.title': 'Cookie settings',
    'trigger.state': 'Your current state',
    'trigger.date': 'Consent date',
    'trigger.id': 'Your consent ID',
    'trigger.change': 'Change your consent',
    'trigger.withdraw': 'Withdraw your consent',
    'trigger.showDetails': 'Show details',
    'trigger.hideDetails': 'Hide details',
    'trigger.none': 'You have not made a cookie choice yet.',
    'trigger.about':
      'We use cookies to improve our services. We use cookies to personalise content and ads and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you have provided to them or that they have collected from your use of their services.\n\n' +
      'Cookies are small text files that can be used by websites to make the user experience more efficient.\n\n' +
      'The law states that we can store cookies on your device if they are strictly necessary for the operation of this site. For all other types of cookies we need your permission.\n\n' +
      'This site uses different types of cookies. Some cookies are placed by third-party services that appear on our pages.\n\n' +
      'You can at any time change or withdraw your consent from the Cookie Declaration on our website.\n\n' +
      'Learn more about who we are, how you can contact us and how we process personal data in our Privacy Policy.\n\n' +
      'Please state your consent ID and date when you contact us regarding your consent.',
    'trigger.domains': 'Your consent applies to the following domains:',
    'trigger.colName': 'Name',
    'trigger.colProvider': 'Provider',
    'trigger.colPurpose': 'Purpose',
    'trigger.colExpiry': 'Expiry',
    'trigger.colType': 'Type',
    'trigger.noCookies': 'We do not use cookies of this type.',
    'type.cookie': 'HTTP cookie',
    'type.localStorage': 'Local storage',
    'type.indexedDb': 'IndexedDB',
    'type.pixel': 'Pixel',
    'type.other': 'Other',
  },
};

export class I18n {
  private table: Texts;

  constructor(
    public lang: Lang,
    overrides?: Texts,
  ) {
    // Prázdný přepis = výchozí text (stejně jako vyprázdněné pole v adminu).
    const set = Object.entries(overrides ?? {}).filter(([, v]) => typeof v === 'string' && v.trim() !== '');
    this.table = { ...DEFAULT_TEXTS[lang], ...Object.fromEntries(set) };
  }

  t(key: string): string {
    return this.table[key] ?? key;
  }

  catName(id: CategoryId): string {
    return this.t(`cat.${id}.name`);
  }

  catDesc(id: CategoryId): string {
    return this.t(`cat.${id}.desc`);
  }
}

/** Zjistí jazyk z konfigurace + prostředí prohlížeče. */
export function resolveLang(
  supported: Lang[],
  preferred?: Lang | 'auto',
): Lang {
  const fallback = supported[0] ?? 'cs';
  if (preferred && preferred !== 'auto') {
    return supported.includes(preferred) ? preferred : fallback;
  }
  const candidates: string[] = [];
  const htmlLang = document.documentElement.getAttribute('lang');
  if (htmlLang) candidates.push(htmlLang);
  if (navigator.language) candidates.push(navigator.language);
  candidates.push(...(navigator.languages ?? []));
  for (const c of candidates) {
    const short = c.slice(0, 2).toLowerCase() as Lang;
    if (supported.includes(short)) return short;
  }
  return fallback;
}
